/**
 * Trainova AI — PermissionGate Component
 *
 * Conditionally renders UI elements based on user permissions.
 */

import { ReactNode } from 'react';
import { usePermissions, PermissionCode } from '../hooks/usePermissions';

interface PermissionGateProps {
  permission: PermissionCode;
  fallback?: ReactNode;
  children: ReactNode;
}

export function PermissionGate({ permission, fallback = null, children }: PermissionGateProps) {
  const { can } = usePermissions();

  if (!can(permission)) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
}
